import { AuxButton, AuxInlineMenu } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum, AuxButtonSizeEnum } from "@blk/aladdin-web-components";
import React from "react";
export const InsInlineMenu = (props) => {
    const insInlineMenuItemClicked = (event) => {
        const { action } = props.items[event.detail.element.key];
        if (action !== undefined) {
            action();
        }
    };
    const data = [[]];
    props.items.forEach((item, index) => {
        data[0].push({
            key: index,
            ...item
        });
    });
    return React.createElement(AuxInlineMenu, { onInlineMenuItemClicked: insInlineMenuItemClicked, data: data },
        React.createElement(AuxButton, { icon: props.icon, "is-icon-right": true, label: props.label, slot: "target", size: AuxButtonSizeEnum.SMALL, type: AuxButtonTypeEnum.SECONDARY, isDisabled: props.isDisabled }));
};
